import { UnitActionsList, UnitType } from "../actions/unitActions";
import { Action } from "../actions/types";

const initialValue: Array<UnitType> = []

export const UnitReducer = (state: UnitType[] = initialValue, action: Action) => {

    switch (action.type) {

        case UnitActionsList.ADD_UNIT: {

            return [...state, action.data]
        }

        case UnitActionsList.EDIT_UNIT: {

            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated
        }

        case UnitActionsList.FETCH_UNIT: {

            return action.data

        }

        case UnitActionsList.DELETE_UNIT: {
            return state.filter(i => i.id !== action.data.id)

        }

        default: return state
    }

}